var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:" text-lg font-bold",class:_vm.classes},[_vm._v(" "+_vm._s(_vm.caption)+" ")]),_c('p',{staticClass:"text-sm font-bold border-b",class:_vm.classes},[_vm._v(" "+_vm._s(_vm.description)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }